import { Link } from "react-router-dom";
import Navbar from "../components/ui/navbar";
const ReferencePage = () => {
  return (
    <>
      <div className="relative flex-shrink-0 w-full py-8 border-b border-1">
        <Navbar />
      </div>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-5xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
          <div className="mb-8 overflow-hidden transition-all bg-white border border-gray-200 shadow-lg rounded-xl hover:shadow-xl">
            <div className="flex items-center px-8 py-5 text-white bg-gradient-to-r from-blue-900 to-blue-700">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <h2 className="text-xl font-bold tracking-wide">Citation</h2>
            </div>
            <div className="p-8">
              <h3 className="mb-4 text-2xl font-bold leading-snug text-gray-900">
                Lipid Nanoparticle Database towards Structure-Function Modeling
                and Data-driven Design for Nucleic Acid Delivery
              </h3>
              <p className="mb-6 text-lg leading-relaxed text-gray-700">
                E. Collins, J. Ji, S-G. Kim, J. Witten, S. Kim, R. Zhu, P. Park,
                M. Jung, A. Park, R.S. Manan, A. Rudra, G. Keum, E-K. Bang, J-O
                Jin, W.J. Jeang, R. Langer, D.G. Anderson, and W. Im
              </p>
              <div className="flex items-center leading-relaxed">
                <Link
                  to="https://doi.org/10.1038/s41467-026-68818-1"
                  target="_blank"
                >
                  <span className="inline-flex items-center py-1 text-lg italic font-medium text-blue-600 hover:underline">
                    Nat Commun 17, 2464 (2026)
                  </span>
                </Link>
              </div>
              <div className="flex justify-center mt-5">
                {/* <button className="inline-flex items-center px-5 py-2 text-sm font-medium text-white transition-colors duration-200 bg-blue-800 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                  Download BibTeX
                </button> */}
              </div>
            </div>
          </div>
          {/*
          <div className="mb-8 overflow-hidden transition-all bg-white rounded-lg shadow-md hover:shadow-lg">
            <div className="flex items-center px-6 py-4 text-white bg-blue-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <h2 className="text-lg font-semibold">Authors</h2>
            </div>

            <div className="p-6">
              {/* Co-first authors 
              <div className="mb-6">
                <h3 className="pb-2 mb-4 text-lg font-medium text-blue-800 border-b border-blue-100">
                  Co-first Authors{" "}
                  <span className="text-sm font-normal text-blue-600">
                    *equal contribution
                  </span>
                </h3>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                  {mainAuthors.map((author, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center justify-center p-4 text-center rounded-lg bg-blue-50"
                    >
                      <div className="flex items-center justify-center w-16 h-16 mb-3 bg-blue-200 rounded-full">
                        <span className="text-xl font-bold text-blue-800">
                          {author.name.split(" ")[0][0]}
                          {author.name.split(" ")[1][0]}
                        </span>
                      </div>
                      <h4 className="font-semibold text-gray-800">
                        {author.name}
                      </h4>
                      <span className="mt-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        Co-first Author
                      </span>
                    </div>
                  ))}
                </div>
              </div>


              <div className="mb-6">
                <h3 className="pb-2 mb-4 text-lg font-medium text-blue-800 border-b border-blue-100">
                  Contributing Authors
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-3">
                  {otherAuthors.map((author, index) => (
                    <div key={index} className="flex items-center">
                      <div className="flex items-center justify-center w-8 h-8 mr-3 bg-blue-100 rounded-full">
                        <span className="text-sm font-medium text-blue-800">
                          {author.split(" ")[0][0]}
                          {author.split(" ").length > 1
                            ? author.split(" ")[1][0]
                            : ""}
                        </span>
                      </div>
                      <span className="text-gray-700">{author}</span>
                    </div>
                  ))}
                </div>
              </div>


              <div>
                <h3 className="pb-2 mb-4 text-lg font-medium text-blue-800 border-b border-blue-100">
                  Senior Authors
                </h3>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                  {seniorAuthors.map((author, index) => (
                    <div key={index} className="p-4 rounded-lg bg-blue-50">
                      <h4 className="font-semibold text-gray-800">
                        {author.name}
                      </h4>
                      <p className="mt-1 text-sm text-gray-600">
                        {author.affiliation}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          Funding Card
          <div className="overflow-hidden transition-all bg-white rounded-lg shadow-md hover:shadow-lg">
            <div className="flex items-center px-6 py-4 text-white bg-blue-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h2 className="text-lg font-semibold">
                Funding and Acknowledgments
              </h2>
            </div>
            <div className="p-6">
              <p className="mb-4 text-gray-700">
                This work was supported by grants from the National Institutes
                of Health (R01xxXXXXXX to W.I.), the National Science Foundation
                (Grant XXXXXXX to D.G.A.), and the Koch Institute Support (core)
                Grant P30-CA14051 from the National Cancer Institute.
              </p>
              <p className="text-gray-700">
                We thank members of the Im, Anderson, and Langer laboratories
                for helpful discussions. The computations were performed using
                resources supported by the Scientific Computing and
                Visualization group at Boston University and the Research
                Computing at Lehigh University.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ReferencePage;
